<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import type { Schemas } from '@shopware/api-client/api-types';

const { getFormattedPrice } = usePrice();
const { addPromotionCode, consumeCartErrors, cart, removeItem } = useCart();

const input = ref('');

const cartErrors = ref<Schemas['Cart']['errors']>([]);

const addPromotion = async code => {
    input.value = '';
    try {
        const response = await addPromotionCode(code);
        input.value = '';
        if (response.errors) {
            cartErrors.value = consumeCartErrors();
            return;
        }
    } catch (e) {
        console.error(e);
        input.value = '';
    }
};

const promotions = computed(() => {
    return cart.value.lineItems.filter(lineItem => lineItem.type === 'promotion');
});
</script>

<template>
    
<FormKitLazyProvider config-file="true">
<ul
        v-if="cartErrors && cartErrors['promotion-not-found']"
        class="validation-errors bg-accent-red-light p-5"
    >
        <li class="flex place-items-center gap-2 text-sm">
            <FormKitIcon
                icon="circle-xmark"
                class="block h-6 w-6 text-accent-red"
            />
            {{ cartErrors['promotion-not-found'].message }}
        </li>
    </ul>
    <div class="mb-3 flex flex-col gap-2">
        <FormKit
            id="checkout-promotion"
            v-model="input"
            :floating-label="false"
            type="text"
            :placeholder="$t('checkout.promotion.code.label')"
            name="promotionCode"
            :classes="{
                inner: '!rounded-full px-4',
                input: 'text-sm',
                suffixIcon: '!w-3',
            }"
            suffix-icon="arrow-right"
            @suffix-icon-click="addPromotion(input)"
            @keyup.enter="addPromotion(input)"
        />
        <div
            v-for="promotion in promotions"
            :key="promotion.id"
            class="flex place-items-center rounded-md bg-accent-orange-light"
        >
            <div class="rounded-l-md bg-accent-orange">
                <FormKitIcon
                    icon="percent"
                    class="m-2 block h-4 w-4 text-neutral-100"
                />
            </div>
            <div class="ml-3 flex w-full place-items-center justify-between text-sm">
                <div>
                    <span class="uppercase">{{ promotion.payload.code }}</span> ({{
                        getFormattedPrice(promotion.price.totalPrice)
                    }})
                </div>
                <FormKitIcon
                    icon="trash"
                    class="m-2 block h-4 w-4"
                    @click="removeItem(promotion)"
                />
            </div>
        </div>
    </div>
</FormKitLazyProvider>

</template>
